export const urlWithHttps = (initialUrl: string) => {
    let url: URL;

    try {
        url = new URL(initialUrl);

        if (!url.hostname) {
            url = new URL(`https://${initialUrl}`);
        }
    } catch (error) {
        url = new URL(`https://${initialUrl}`);
    }

    return url.href;
};
